import { TableCell, TableRow } from '@mui/material'
import React from 'react'
import SuppliersFormAdd from './form/SuppliersFormAdd'
import { Link } from 'react-router-dom'

const SupplierItem = ({ supplier }) => {    

  return (
    <TableRow>
        <TableCell align='center'>
            <Link to={`/supply/suppliers/${supplier.id}`}>
                {supplier.id}
            </Link>
        </TableCell>
        <TableCell align='center'>
            {supplier.edrpou}
        </TableCell>
        <TableCell align='center'>
            {supplier.name}
        </TableCell>
        <TableCell align="center" className='myTable__actions'>
            <SuppliersFormAdd 
                supplier={supplier}
            />
        </TableCell>
    </TableRow>
  )
}

export default SupplierItem